import { getResponsiveProp, responsive } from '../helpers';
export function flexItemStyle() {
    return [{ minWidth: 0, minHeight: 0 }, responsiveFlexItemStyle];
}
export function responsiveFlexItemStyle(props) {
    const { theme } = props;
    const { media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$flex), (flex) => ({ flex }));
}
//# sourceMappingURL=flexItemStyle.js.map